import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "accident-history",
  components: {
    AppHeader
  },
  created() {
    this.getUser();
    this.getAccidentHistory();
  },
  data() {
    return {
      getAccidentHistoryEnd: false,
      accidentHistories: [],
      user: ""
    };
  },
  methods: {
    async getUser() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_USER", {
          id: this.$route.params.user_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.user = res.user;
    },
    async getAccidentHistory() {
      this.getAccidentHistoryEnd = false;
      let data = {
        user_id: this.$route.params.user_id
      };
      let res = await this.$store
        .dispatch("GET_ACCIDENT_HISTORY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.accidentHistories = res.accident_histories;
      this.getAccidentHistoryEnd = true;
    },
    deleteModal(accidentHistoryId) {
      this.deleteAccidentHistoryId = accidentHistoryId;
      this.$bvModal.show("modal-delete");
    },
    async deleteAccidentHistory() {
      let res = await this.$store
        .dispatch("DELETE_ACCIDENT_HISTORY", {
          id: this.deleteAccidentHistoryId,
          data: {}
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (!res.error) {
        this.getAccidentHistory();
      }
      this.$bvModal.hide("modal-delete");
    },
    goUserDetail() {
      this.$router.push({ path: `/user/${this.$route.params.user_id}` });
    },
    goRankHistory() {
      this.$router.push({
        path: `/rank_history/${this.$route.params.user_id}`
      });
    },
    goAccidentHistoryNew() {
      this.$router.push({
        path: `/accident_history/${this.$route.params.user_id}/new`
      });
    },
    goAccidentHistoryEdit(rankHistoryId) {
      this.$router.push({ path: `/accident_history/${rankHistoryId}/edit` });
    },
    content(word) {
      return word
        ? word
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;")
            .replace(/\r?\n/g, "<br>")
        : "";
    },
    dateFormat(date) {
      return dayjs(date).format("YYYY年MM月DD日");
    }
  }
};
